import { render, staticRenderFns } from "./ambassadorapp.vue?vue&type=template&id=2df677aa&scoped=true&"
import script from "./ambassadorapp.vue?vue&type=script&lang=js&"
export * from "./ambassadorapp.vue?vue&type=script&lang=js&"
import style0 from "./ambassadorapp.vue?vue&type=style&index=0&id=2df677aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df677aa",
  null
  
)

export default component.exports